module.exports = __webpack_public_path__ + "assets/Instagram.a34bbcdf.svg";